'use client'
import Image from "next/image";
import { Inter } from "next/font/google";
import MainLayout from "@/components/Layouts/Main";
import { useEffect, useRef, useState } from "react";
import HeroBookeeping from "@/components/PageServices/Bookeeping/Hero";
import Reasons from "@/components/PageServices/Bookeeping/Reasons";
import Benefit from "@/components/PageServices/Bookeeping/Benefit";
import PricingList from "@/components/PageServices/Bookeeping/PricingList";
import CallToAction from "@/components/CallToAction/CallToAction";
import Faq from "@/components/Faq/Faq";
import { faqBookeeping } from "@/helpers/content/id/services/bookeeping/faq";
import { listReasonsBookeeping } from "@/helpers/content/id/services/bookeeping/reasons";
import { useRouter } from "next/router";
import { getCookie } from 'cookies-next'
import { bookkeepingContact } from "@/helpers/content/id/services/bookeeping/contact";
import * as ga from "@/libs/analytics";
import { useTranslation } from 'react-i18next';

const inter = Inter({ subsets: ["latin"] });

export default function Bookeeping() {
  const { t } = useTranslation();
  const language = getCookie('NEXT_LOCALE') || 'id';
  const [isShowBar, setisShowBar] = useState(false)
  const homeRef = useRef()
  const pricingRef = useRef()
  const servicesRef = useRef()
  const servicesMobileRef = useRef([])
  const servicesMainMobileRef = useRef()
  const contactRef = useRef()
  const clientRef = useRef()
  const [nextTab, setnextTab] = useState(0)
  const [nextTabMobile, setnextTabMobile] = useState(0)
  const [servicesElementScroll, setservicesElementScroll] = useState(0)
  const [faq, setFaq] = useState(faqBookeeping)

  const router = useRouter()

  useEffect(() => {
    const head = document.head;
    const script = document.createElement("script");
    script.innerHTML = `
      setTimeout(function(){var a=document.createElement("script");
      var b=document.getElementsByTagName("script")[0];
      a.src=document.location.protocol+"//script.crazyegg.com/pages/scripts/0055/6070.js?"+Math.floor(new Date().getTime()/3600000);
      a.async=true;a.type="text/javascript";b.parentNode.insertBefore(a,b)}, 1);
    `;
    head.appendChild(script);
    const handleRouteChange = (url) => {
      ga.pageview(url);
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);


  useEffect(() => {
    const getLocalStorage = JSON.parse(localStorage.getItem("type"))
    if (getLocalStorage) {
      console.log("local storage",getLocalStorage)
      if (getLocalStorage.index) {
        if (getLocalStorage.scrollTo == "services") {
          setnextTab(getLocalStorage.index)
        }else if(getLocalStorage.scrollTo == "services-mobile"){
          setnextTabMobile(getLocalStorage.index)
        }
        moveToSection(getLocalStorage.scrollTo, getLocalStorage.index)
      }else{
        moveToSection(getLocalStorage.scrollTo)
      }
    }
    localStorage.removeItem("type")
  }, [])
  

  const moveToSection = (type, index = 0) => {
    if (type == "pricingRef") {
      window.scrollTo({top: pricingRef.current.offsetTop, behavior:"smooth" })
    }else if(type == "client"){
      setisShowBar(false)
      window.location.href = "/"
      localStorage.setItem("type",JSON.stringify({scrollTo:"client"}))
    }else if (type == "services") {
      setisShowBar(false)
      // setnextTab(index)
      window.scrollTo({
        top: servicesRef.current.offsetTop, 
        behavior:"smooth"
      })
    }
    else if (type == "services-mobile") {
      console.log(index)
      setservicesElementScroll(prev => prev > 0 ? prev : servicesMainMobileRef.current.getBoundingClientRect().top - 100)
      setisShowBar(false)
      setnextTabMobile(index)
      // setTimeout(() => {
      //   window.scrollTo({
      //     top: servicesMainMobileRef.current.getBoundingClientRect().top,
      //     bottom: servicesMainMobileRef.current.getBoundingClientRect().bottom,
      //     behavior:"smooth"
      //   })
      // }, 100);
    }
    else if(type == "article"){
      window.open("https://blog.ledgerowl.com/","_blank")
    }else if(type == "home") { 
      window.scrollTo({
        top: homeRef.current.offsetTop,
        behavior:"smooth"
      })
    }else if(type == "contact") { 
      window.scrollTo({
        top: contactRef.current.offsetTop,
        behavior:"smooth"
      })
    }else if(type == "consultation"){
      window.scrollTo({
        top: contactRef.current.offsetTop,
        behavior:"smooth"
      })
      // window.open("https://api.whatsapp.com/send?phone=6281287889023&text=%20%20Hi!%20Can%20I%20ask%20more%20on%20ledgerowl%20services%20%3f","_blank")
    }
  }

  useEffect(() => {
    // window.scrollTo({
    //   top: servicesElementScroll,
    //   behavior:"smooth"
    // })
  }, [servicesElementScroll])
  return (
    <MainLayout
      setnextTab={setnextTab}
      setnextTabMobile={setnextTabMobile}
      setisShowBar={setisShowBar}
      isShowBar={isShowBar}
      moveToSection={moveToSection}
      textWa={t("floating_message_service_bookkeeping")}
    >
      <HeroBookeeping moveToSection={moveToSection}/>
      <div className='relative flex max-w-[1280px] lg:mx-auto lg:container flex-col w-full px-4 py-16 -top-[8rem] lg:px-8 lg:py-[100px] bg-base-white'>
        <Reasons list={listReasonsBookeeping}/>
      </div>
      <Benefit language={language}/>
      <PricingList moveToSection={moveToSection} pricingRef={pricingRef}/>
      <Faq faq={faq}/>
      <CallToAction contact={bookkeepingContact} service={"Pembukuan"} contactRef={contactRef} textWa={t("floating_message_service_bookkeeping")} />
    </MainLayout>
  )
}
